import { connect } from 'react-redux';
import { TemplateOption } from './component';
import { getTemplateItems } from './selectors';
import { changePageTemplate } from '../actions';
const mapStateToProps = (state) => {
    return {
        // TODO zrusit selector a pocitat to primo v reducers/page
        value: state.page.templateIdent,
        items: getTemplateItems(state),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (e) => {
            dispatch(changePageTemplate(e.target.value));
        },
    };
};
export const TemplateOptionContainer = connect(mapStateToProps, mapDispatchToProps)(TemplateOption);
//# sourceMappingURL=container.js.map